module.exports = __webpack_public_path__ + "media/country_flags/lv-d71d970e.png";